<section
    class="product-attributes paragraph-small"
    [ngClass]="{
        'border-top': borderTop,
        'border-bottom': borderBottom,
        'spacing-bottom': spacingBottom,
        'margin-bottom': marginBottom,
        'background-opacity': backgroundOpacity
    }">
    @if (product.attributes.description) {
    <section [attr.aria-labelledby]="'product_desc'">
        <span
            hSrOnlyNoSnippet
            id="product_desc"
            role="heading"
            i18n-role
            aria-level="3"
            i18n="@@hermes.accessibility.product-info.description">
            Product description
        </span>

        <h-product-info-description [description]="product.attributes.description"></h-product-info-description>

        <!-- Displaying "Country of Manufacture" attribute -->
        @if (madeInValue) {
        <p class="product-attribute-font paragraph-small" [innerHTML]="madeInValue"> </p>
        }

        <!-- Displaying "finish information" attribute -->
        @if (finish && finishLabel) {
        <p class="product-attribute-font paragraph-small">
            {{ finishLabel | hSpaceSeparator : ":" : finish }}
        </p>
        }

        <!-- Displaying "metalTitration" attributes -->
        @for ( metalTitration of [ product?.attributes?.metalTitration1, product?.attributes?.metalTitration2,
        product?.attributes?.metalTitration3 ] ; track trackByAttributes(idx); let idx = $index) { @if (metalTitration)
        {
        <p class="product-attribute-font paragraph-small" [innerHTML]="metalTitration"> </p>
        } } @if (product.attributes.designerLabel && product.attributes.designer) {
        <p class="product-attribute-font paragraph-small">
            <span [innerHTML]="product.attributes.designerLabel"></span>&nbsp;<span
                [innerHTML]="product.attributes.designer"></span>
        </p>
        } @if (product.attributes.dimensions) {
        <p class="product-attribute-font paragraph-small" [innerHTML]="product.attributes.dimensions"> </p>
        }

        <!-- Displaying volume information -->
        @for ( measureUnit of [ product.simpleAttributes?.measureUnit, product.doubleFragranceAttributes?.measureUnit ]
        ; track trackByAttributes(idx); let idx = $index) { @if (product.massVolume && measureUnit) {
        <p class="product-attribute-font paragraph-small">
            <ng-container i18n="@@hermes.product-details.capacity.label">capacity</ng-container>
            {{ product.massVolume }}&nbsp;{{ measureUnit }}
        </p>
        } }

        <!-- Displaying Apple Watch information -->
        @for ( appleWatchAttribute of [ product.appleWatchAttributes?.dimensionGuizmo,
        product.appleWatchAttributes?.dimensionStrap ] ; track trackByAttributes(idx); let idx = $index) { @if
        (appleWatchAttribute) {
        <p class="product-attribute-font paragraph-small" [innerHTML]="appleWatchAttribute"> </p>
        } }
    </section>
    }
</section>
